<template>
  <v-card id="report-create-form" class="py-4">
    <v-card-text>
      <h4 class="mb-4">{{ $t('create_a_new_report') }}</h4>
      <div id="select-report-type">
        <v-select
          outlined
          :label="$t('select_a_report_type')"
          v-model="selectedReport"
          :items="reportOptions"
          item-text="name"
          item-value="type"
          :menu-props="{ 'maxHeight': 500 }">
        </v-select>
      </div>
      <div v-if="selectedReport">
        <hr class="mb-5">
        <div class="d-flex align-center">
          <p class="flex-grow-1">{{ selectedReportObject.infoText }}</p>
          <div class="flex-grow-0 ml-3">
            <v-dialog width="66%">
              <img :src="selectedReportObject.exampleImage"/>
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" v-on="on" outlined color="primary">
                  {{ $t('reports_ui.view_sample_report') }}
                </v-btn>
              </template>
            </v-dialog>
          </div>
        </div>
        <h5>{{ $t('report_parameters') }}</h5>
        <component
          ref="report-form"
          v-bind:is="selectedReportObject.form"
          v-on:report-saved.once="redirectTo"
          v-on:report-validation-fail="handleValidationFail($event)"
          v-on:report-error="handleReportError($event)"
          :report="reportTemplate"
          context="create"/>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn text color="gray" @click="$emit('close')">
        {{ $t('close') }}
      </v-btn>
      <v-btn :loading="saving" :disabled="!selectedReport" color="primary" text @click="generateReport()">
        <v-icon>mdi-arrow-right</v-icon>
        {{ $t('run_report') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ReportIndex from '@/components/report/ReportIndex'
import VehicleViolationReportForm from '@/components/report/VehicleViolationReportForm'
import StartTemperaturesReportForm from '@/components/report/StartTemperaturesReportForm'
import MissedStopsReportForm from '@/components/report/MissedStopsReportForm'
import SiteViolationReportForm from '@/components/report/SiteViolationReportForm'
import MonthlyRouteStatusReportForm from '@/components/report/MonthlyRouteStatusReportForm'
import RootCauseReportForm from '@/components/report/RootCauseReportForm'
import CustomerMetricsReportForm from '@/components/report/CustomerMetricsReportForm'
import RouteDataQualityReportForm from '@/components/report/RouteDataQualityReportForm'
import FleetHealthReportForm from '@/components/report/fleet-health/FleetHealthReportForm'
import RouteAssessmentMetricsReportForm from '@/components/report/route-assessment-metrics/RouteAssessmentMetricsReportForm'
import WeeklyPerformanceReportForm from '@/components/report/WeeklyPerformanceReportForm'
import WeeklyScorecardReportForm from '@/components/report/WeeklyScorecardReportForm'
import RCAReportForm from '@/components/report/RCAReportForm'
import StartTempLogReportForm from '@/components/report/StartTempLogReportForm'
import VehicleCountReportForm from '@/components/report/VehicleCountReportForm.vue';
import ForecastViolationValidationReportForm from '@/components/report/ForecastViolationValidationReportForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'


import { find } from 'lodash'

export default {
  name: 'ReportCreateForm',
  components: {
    ReportIndex,
    VehicleViolationReportForm,
    StartTemperaturesReportForm,
    MissedStopsReportForm,
    SiteViolationReportForm,
    MonthlyRouteStatusReportForm,
    RootCauseReportForm,
    CustomerMetricsReportForm,
    RouteDataQualityReportForm,
    FleetHealthReportForm,
    RouteAssessmentMetricsReportForm,
    WeeklyPerformanceReportForm,
    WeeklyScorecardReportForm,
    RCAReportForm,
    StartTempLogReportForm,
    VehicleCountReportForm,
    ForecastViolationValidationReportForm
  },
  mixins: [
    BrowserUtilitiesMixin,
    CurrentUserMixin
  ],
  props: {
    reportOptions: Array
  },
  data () {
    return {
      saving: false,
      selectedReport: null,
      reportTemplate: this.$orm('Report').createRecord({ parameters: {} })
    }
  },
  methods: {
    redirectTo (report) {
      this.saving = false
      this.$router.push(`/report/${report.id}`)
    },
    setReportType (type) {
      this.selectedReport = type
    },
    preFillForm (report) {
      this.selectedReport = report.type
      this.reportTemplate = report
    },
    generateReport () {
      this.saving = true
      this.$refs['report-form'].createReport()
    },
    handleValidationFail (event) {
      this.saving = false
    },
    handleReportError (error) {
      this.saving = false
      this.handleError(error)
    }
  },
  computed: {
    selectedReportObject () {
      return this.selectedReport ? find(this.reportOptions, x => x.type === this.selectedReport) : {}
    }
  },
  mounted () {
    this.updateBrowserTitle(this.$tc('report', 2))
  }
}

</script>

<style scoped lang="scss">
#select-report-type {
  width: 400px;
}
</style>
